export default "__VITE_ASSET__ZA8y1H6B__"